import axios from "../axios-defaults";
const getUploadUrl = (filename) => {
  return axios.get(`/v1/s3-presigned-upload-url?key=${filename}`);
};

export default getUploadUrl;
